import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import AddOrEditCategoryForm from "./AddOrEditCategoryForm";
import ModalCloseIcon from "../../common/Components/Icons/ModalCloseIcon";
const CategoryModal = (props: any) => {
  const { openModal, closeModal, editData, getAllData, handleName, form } =
    props;

  return (
    <Modal
      isOpen={openModal}
      toggle={closeModal}
      size="lg"
      fade={false}
      className="CategoryModal"
    >
      <ModalHeader>
        <div className="Heading">
          <h3>{editData?._id ? "Edit Category" : "Add New Category"}</h3>
          <ModalCloseIcon {...props} closeModal={closeModal} />
        </div>
      </ModalHeader>
      <ModalBody>
        <AddOrEditCategoryForm
          {...props}
          closeModal={closeModal}
          editData={editData}
          getAllData={getAllData}
          handleName={handleName}
          form={form}
        />
      </ModalBody>
    </Modal>
  );
};

export default CategoryModal;
